import { System } from '@combos-fun/engine';
import type { UpdateParams } from '@combos-fun/engine';
import ThreeContext from './ThreeContext';
import type { ThreeContextParams } from './ThreeContext';
import Renderer3DManager from './Renderer3DManager';

export interface Renderer3DSystemParams extends Partial<ThreeContextParams> {
  canvas?: HTMLCanvasElement;
  container?: HTMLElement;
  width?: number;
  height?: number;
  antialias?: boolean;
  backgroundColor?: number;
  backgroundAlpha?: number;
}

export default class Renderer3DSystem extends System<Renderer3DSystemParams> {
  static systemName = 'Renderer3DSystem';
  name: string = 'Renderer3DSystem';
  threeContext: ThreeContext;
  rendererManager: Renderer3DManager;

  init(params?: Renderer3DSystemParams) {
    const opts = params || {};
    const width = opts.width || 750;
    const height = opts.height || 1000;

    this.threeContext = new ThreeContext({
      canvas: opts.canvas,
      container: opts.container,
      width,
      height,
      antialias: opts.antialias,
      backgroundColor: opts.backgroundColor,
      backgroundAlpha: opts.backgroundAlpha,
    });

    this.game.canvas = this.threeContext.renderer.domElement;

    this.rendererManager = new Renderer3DManager({
      game: this.game,
      rendererSystem: this,
    });
  }

  update(e?: UpdateParams) {
    for (const gameObject of this.game.gameObjects) {
      this.rendererManager.update(gameObject);
    }
  }

  lateUpdate() {
    this.threeContext?.update();
  }

  resize(width: number, height: number) {
    this.threeContext?.resize(width, height);
  }

  onDestroy(): void {
    this.threeContext?.destroy();
    this.threeContext = null;
  }
}
